// Use this for global constants
// If specific, then group them under a object.
const TASKLIST_ROLE_DEFINITIONS = Object.freeze({
  MANAGER: { value: 'manager', label: 'Manager' },
  PREPARER: { value: 'preparer', label: 'Preparer' },
  APPROVER: { value: 'approver', label: 'Approver' },
});

const TASKLIST_ROLES = Object.freeze(
  Object.fromEntries(
    Object.entries(TASKLIST_ROLE_DEFINITIONS).map(([key, role]) => [key, role.value]),
  ),
);

const TASKLIST_ROLE_OPTIONS = Object.freeze(Object.values(TASKLIST_ROLE_DEFINITIONS));

const TASKLIST_ROLE_VALUES = Object.freeze(
  TASKLIST_ROLE_OPTIONS.map((role) => role.value),
);

const TASKLIST_NON_MANAGER_ROLE_VALUES = Object.freeze(
  TASKLIST_ROLE_VALUES.filter((value) => value !== TASKLIST_ROLES.MANAGER),
);

export default {
  APP: {
    TITLE: 'Consark.ai',
  },
  AUTH: {
    SESSION_EXPIRED_CODES: ["UL403"],
    REDIRECT_DEBOUNCE_MS: 2000,
  },
  BULK_FILE_TEMPLATES: {
    EN: "en",
    LABELS_PAGE: "reporting_units_bulk_file",
    ERROR_MESSAGES: "reporting_units_error_messages",
    BULK_SUBMIT_COLUMNS_ACTUAL: [
      "GL Code",
      "Description",
      "Actual Amount",
      "Proforma Amount",
      "Variance Amt(Act vs Pro)",
      "Variance %(Act vs Pro)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local Act vs Pro Commentary",
      "Regional Act vs Pro Commentary",
      "Forecast Amount",
      "Variance Amt(Act vs For)",
      "Variance %(Act vs For)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local Act vs For Commentary",
      "Regional Act vs For Commentary",
      "Status Local",
      "Status Regional",
      "Local Approve/Reject (Yes/No)",
      "Local Approve/Reject Reason",
      "Regional Approve/Reject (Yes/No)",
      "Reject - Local Level (LA/LP)",
      "Regional Approve/Reject Reason",
      "Local Approve & Submit (Yes/No)",
      "Local Approve & Submit Reason",
    ],
    BULK_SUBMIT_COLUMNS_FORECAST: [
      "GL Code",
      "Description",
      "Forecast Amount",
      "Proforma Amount",
      "Variance Amt(For vs Pro)",
      "Variance %(For vs Pro)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local For vs Pro Commentary",
      "Regional For vs Pro Commentary",
      "Previous Forecast Amount",
      "Variance Amt(For vs Prev For)",
      "Variance %(For vs Prev For)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local For vs Prev For Commentary",
      "Regional For vs Prev For Commentary",
      "Status Local",
      "Status Regional",
      "Local Approve/Reject (Yes/No)",
      "Local Approve/Reject Reason",
      "Regional Approve/Reject (Yes/No)",
      "Reject - Local Level (LA/LP)",
      "Regional Approve/Reject Reason",
      "Local Approve & Submit (Yes/No)",
      "Local Approve & Submit Reason",
    ],
    BULK_SUBMIT_COLUMNS_ACTUAL_BS: [
      "GL Code",
      "Description",
      "Actual Amount",
      "Proforma Amount",
      "Variance Amt(Act vs Pro)",
      "Variance %(Act vs Pro)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local Act vs Pro Commentary",
      "Regional Act vs Pro Commentary",
      "Forecast Amount",
      "Variance Amt(Act vs For)",
      "Variance %(Act vs For)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local Act vs For Commentary",
      "Regional Act vs For Commentary",
      "Status Local",
      "Status Regional",
      "Local Approve/Reject (Yes/No)",
      "Local Approve/Reject Reason",
      "Regional Approve/Reject (Yes/No)",
      "Reject - Local Level (LA/LP)",
      "Regional Approve/Reject Reason",
      "Local Approve & Submit (Yes/No)",
      "Local Approve & Submit Reason",
    ],
    BULK_SUBMIT_COLUMNS_FORECAST_BS: [
      "GL Code",
      "Description",
      "Forecast Amount",
      "Proforma Amount",
      "Variance Amt(For vs Pro)",
      "Variance %(For vs Pro)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local For vs Pro Commentary",
      "Regional For vs Pro Commentary",
      "Previous Forecast Amount",
      "Variance Amt(For vs Prev For)",
      "Variance %(For vs Prev For)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local For vs Prev For Commentary",
      "Regional For vs Prev For Commentary",
      "Status Local",
      "Status Regional",
      "Local Approve/Reject (Yes/No)",
      "Local Approve/Reject Reason",
      "Regional Approve/Reject (Yes/No)",
      "Reject - Local Level (LA/LP)",
      "Regional Approve/Reject Reason",
      "Local Approve & Submit (Yes/No)",
      "Local Approve & Submit Reason",
    ],
    BULK_MATERIALITY_RU_LEVEL_UPLOAD: [
      "RU Code",
      "Name of Reporting Unit",
      "Month",
      "Year",
      "LC Amt",
      "LC %",
      "LM Amt",
      "LM %",
      "RC Amt",
      "RC %",
      "RM Amt",
      "RM %",
      "LC Amt",
      "LC %",
      "LM Amt",
      "LM %",
      "RC Amt",
      "RC %",
      "RM Amt",
      "RM %",
    ],
    BULK_MATERIALITY_GL_LEVEL_UPLOAD: [
      "RU Code",
      "Name of Reporting Unit",
      "GL Code",
      "GL Description",
     "Month",
      "Year",
      "LC Amt",
      "LC %",
      "LM Amt",
      "LM %",
      "RC Amt",
      "RC %",
      "RM Amt",
      "RM %",
      "LC Amt",
      "LC %",
      "LM Amt",
      "LM %",
      "RC Amt",
      "RC %",
      "RM Amt",
      "RM %",
    ],
    BULK_MATERIALITY_GL_LEVEL_UPLOAD_INSTRUCTIONS: [
      [null, null],
      [null, "Template to bulk upload materiality details at GL level"],
      [null, null],
      [null, "- RU Codes, GL codes and Period are mandatory columns."],
      [
        null,
        "- The name of the reporting unit and the GL description is not a mandatory column.",
      ],
      [
        null,
        "- Suppose the user updates Local Materiality, all the 3 fields related to Local Materiality computation i.e. Local Control Amount, Local Management Amount and Local Management Percentage should be updated (Please note that the Local and Regional Controls are set to 999,999% by default and cannot be edited). The system does not accept the file even if one of the field is blank. The same logic applies for the Regional Materiality as well.  All the fields for materiality setting within the layer ( Local or Regional ) need to be submitted.",
      ],
      [
        null,
        '- Please note that values added in the "Control %" and "Management %" columns should be in whole numbers and not in decimals. e.g., 10% instead of 0.1%.',
      ],
      [null, "- Currency denomination is in United States Dollars (USD)."],
      [
        null,
        "- All values are in thousands. Example : If the threshold needs to be set at $100,000 then update the value as $100.",
      ],
      [
        null,
        '- Control thresholds percentage values will not be considered since it is already set at 999,999%. Local control and Regional control percentages are non-editable. The default percentage is "999,999%". If any value is entered in the excel file during bulk materiality file upload change request, that value won\'t be considered.',
      ],
      [null, null],
      [
        null,
        "- Ensure the file contains no more than 10,000 line items and is free of errors before uploading.",
      ],
    ],
    BULK_MATERIALITY_RU_LEVEL_UPLOAD_INSTRUCTIONS: [
      [null, null],
      [null, "Template to bulk upload materiality details at RU level"],
      [null, null],
      [null, "- RU Code & Period are mandatory columns."],
      [null, "- The name of the reporting unit is not a mandatory column."],
      [
        null,
        "- Suppose the user updates Local Materiality, all the 3 fields related to Local Materiality computation i.e. Local Control Amount, Local Management Amount and Local Management Percentage should be updated (Please note that the Local and Regional Controls are set to 999,999% by default and cannot be edited). The system does not accept the file even if one of the field is blank. The same logic applies for the Regional Materiality as well.  All the fields for materiality setting within the layer ( Local or Regional ) need to be submitted.",
      ],
      [
        null,
        '- Please note that values added in the "Control %" and "Management %" columns should be in whole numbers and not in decimals. e.g., 10% instead of 0.1%.',
      ],
      [null, "- Currency denomination is in United States Dollars (USD)."],
      [
        null,
        "- All values are in thousands. Example : If the threshold needs to be set at $100,000 then update the value as $100.",
      ],
      [
        null,
        '- Control thresholds percentage values will not be considered since it is already set at 999,999%. Local control and Regional control percentages are non-editable. The default percentage is "999,999%". If any value is entered in the excel file during bulk materiality file upload change request, that value won\'t be considered.',
      ],
      [null, null],
      [
        null,
        "- Ensure the file contains no more than 10,000 line items and is free of errors before uploading.",
      ],
    ],
    BULK_ACCESS_RIGHTS_UPLOAD: [
      "RU Code",
      "Name of Reporting Unit",
      "Local Preparer(s)",
      "Local Approver(s)",
      "Regional Approver(s)",
      "Manager(s)",
    ],
    BULK_ACCESS_RIGHTS_UPLOAD_INSTRUCTIONS: [
      [null, null],
      [null, "Template to bulk upload access details at RU level"],
      [null, null],
      [null, "- RU Codes are mandatory"],
      [
        null,
        "- If the user wants to update only the preparer/approver/manager, the other field can be left blank.",
      ],
      [null, "- The name of the reporting unit is not a mandatory field."],
      [
        null,
        "- Preparer/Approver/Manager for a RU accepts only email id. Multiple emails can be given using comma for separation",
      ],
      [
        null,
        "- Preparer/Approver/Manager for a RU cannot be the same person viz., same email ID.",
      ],
      [
        null,
        "- On upload the application will validate whether the user assigned has access to such reporting units in BFC and only if access is available for such users to BFC will the application make the relevant change in assigning the user roles based on this template",
      ],
      [
        null,
        "- Once this template is uploaded the application will make the necessary changes and forward the same to the admin approver to review and decide on the same",
      ],
      [
        null,
        "- When SOD is disabled, the same user can be assigned to multiple roles within the selected RU",
      ],
      [
        null,
        "- When SOD is disabled and a user is already assigned to an RU, to add additional roles for the same user, include the user entry for both the previously assigned role and all new roles to be assigned",
      ],
    ],
    BULK_WORKFLOW_UPLOAD: [
      "RU Code",
      "Proforma Local Control",
      "Proforma Local Management",
      "Proforma Regional Control",
      "Proforma Regional Management",
      "Forecast Local Control",
      "Forecast Local Management",
      "Forecast Regional Control",
      "Forecast Regional Management",
    ],
    BULK_WORKFLOW_UPLOAD_SHOW_TABLE: [
      "RU Code",
      "RU Name",
      "Proforma Local Control",
      "Proforma Local Management",
      "Proforma Regional Control",
      "Proforma Regional Management",
      "Forecast Local Control",
      "Forecast Local Management",
      "Forecast Regional Control",
      "Forecast Regional Management",
    ],
  },
  UNGROUPED_GL_OFFSET: 10000,
  TASK_LIST_CONSTANTS: {
    TASK_TYPES: {
      NORMAL: "Normal Task",
      ACCOUNT_RECONCILIATION: "Account Reconciliation",
    },
    STATUS_DETAILS: {
      PENDING_SUBMISSION_DUE: 'Pending Submission Due',
      PENDING_SUBMISSION_NOT_DUE: 'Pending Submission Not Due',
      PENDING_SUBMISSION_OVERDUE: 'Pending Submission Overdue',
      PENDING_APPROVAL_DUE: 'Pending Approval Due',
      PENDING_APPROVAL_NOT_DUE: 'Pending Approval Not Due',
      PENDING_APPROVAL_OVERDUE: 'Pending Approval Overdue',
      CLOSED_TASK: 'Closed Task'
    },
    STATUS_ICONS: {
      PENDING_SUBMISSION: 'mdi-timer-sand-paused',
      PENDING_SUBMISSION_NOT_DUE: 'mdi-timer-sand-empty',
      PENDING_SUBMISSION_OVERDUE: 'mdi-timer-sand-full',
      PENDING_APPROVAL: 'mdi-timer-sand-paused',
      PENDING_APPROVAL_NOT_DUE: 'mdi-timer-sand-empty',
      PENDING_APPROVAL_OVERDUE: 'mdi-timer-sand-full',
      CLOSED: 'mdi-check-circle'
    },
    STATUS_COLORS: {
      SUBMISSION: '#C69908',
      APPROVAL: '#4285F4',
      CLOSED: 'green'
    },
    ASSERTIONS: [
      "Existence",
      "Occurrence",
      "Rights and obligations",
      "Completeness",
      "Accuracy valuation and allocation",
      "Cut-off",
      "Classification",
      "Presentation",
    ],
    // Canonical role identifiers
    ROLE_DEFINITIONS: TASKLIST_ROLE_DEFINITIONS,
    ROLES: TASKLIST_ROLES,
    ROLE_OPTIONS: TASKLIST_ROLE_OPTIONS,
    ROLE_VALUES: TASKLIST_ROLE_VALUES,
    NON_MANAGER_ROLE_VALUES: TASKLIST_NON_MANAGER_ROLE_VALUES,
    BOT_LIST: [
      { name: "Lease Schedule", value: "Lease Schedule" },
      { name: "Borrowing Schedule", value: "Borrowing Schedule" },
      { name: "Transaction Matching", value: "Transaction Matching" },
    ],
    LEASE_SCHEDULE_ITEMS: [
      "BS-ROU Asset",
      "BS-Lease Liability",
      "PL-Amortization Cost",
      "PL-Interest Expense",
      "BS-Security Deposit",
      "BS-SD-Interest Income",
    ],
    PRIORITY_LIST: ["High", "Medium", "Low"],
    ERROR_MESSAGES: {
      GL_CODE_REQUIRED:
        'At least one GL must be linked for the "Account Reconciliation" task type.',
      TASK_DESCRIPTION_REQUIRED: 'Task Description is required',
      CATEGORY_REQUIRED: 'Category is required',
      SUBCATEGORY_REQUIRED: 'Sub Category is required',
      CATEGORY_NOT_FROM_COA: 'Category must be selected from Chart of Accounts',
      SUBCATEGORY_NOT_FROM_COA: 'Sub Category must be selected from Chart of Accounts',
      TASK_TYPE_REQUIRED: 'Task Type is required',
      TAG_REQUIRED: 'Tag is required',
      CYCLE_TYPE_REQUIRED: 'Cycle Type is required',
      PRIORITY_REQUIRED: 'Priority is required',
      LOCATION_REQUIRED: 'Location is required',
      PREPARER_REQUIRED: 'Preparer is required',
      APPROVER_REQUIRED: 'Approver is required',
      PREPARER_APPROVER_OVERLAP: 'Preparer and Approver cannot be the same user',
      ACCOUNT_NO_NOT_ALLOWED_NORMAL: 'Account No not allowed for Normal task',
      ACCOUNT_NO_REQUIRED: 'Account No required',
      DUE_DAYS_OUT_OF_RANGE: 'Due Days must be between -200 and 200',
      DUE_DATE_REQUIRED: 'Due Date is required',
    },
    BULK_EDIT_HEADERS_MASTER: [
      { text: "Task Type", value: "task_type" },
      { text: "Reference", value: "ref" },
      { text: "Task Description", value: "description" },
      { text: "Due Days", value: "duedays" },
      { text: "Category", value: "category" },
      { text: "Sub Category", value: "subcategory" },
      { text: "Priority", value: "priority" },
      { text: "Preparer", value: "preparer" },
      { text: "Approver", value: "approver" },
      { text: "Purpose", value: "purpose" },
      { text: "Instruction", value: "instruction" },
      { text: "Tags", value: "tags" },
      { text: "No. of Evidences", value: "evidences" },
      { text: "Account No", value: "glcode" },
      { text: "Location", value: "location" },
    ],
    BULK_EDIT_HEADERS_CLOSE_CYCLE: [
      { text: "Task Type", value: "task_type" },
      { text: "Reference", value: "ref" },
      { text: "Task Description", value: "description" },
      { text: "Due Date (dd/mm/yyyy)", value: "duedate" },
      { text: "Category", value: "category" },
      { text: "Sub Category", value: "subcategory" },
      { text: "Purpose", value: "purpose" },
      { text: "Instruction", value: "instruction" },
      { text: "Priority", value: "priority" },
      { text: "Preparer", value: "preparer" },
      { text: "Approver", value: "approver" },
      { text: "Tags", value: "tags" },
      { text: "No. of Evidences", value: "evidences" },
      { text: "Linked Gl", value: "linkedgl" },
      { text: "Location", value: "location" },
    ],
  },
  EXPECTED_HEADERS_MASTER: [
    'Description', 'Category', 'Sub Category', 'Location', 'Assertions',
    'Purpose', 'Instruction', 'Preparer', 'Approver', 'Tags',
    'Due Days', 'Account No', 'Priority', 'No. of Evidences', 'Skip Validation'
      ],
  EXPECTED_HEADERS_CLOSE_CYCLE: [
    "Description",
    "Category",
    "Sub Category",
    "Location",
    "Assertions",
    "Purpose",
    "Instruction",
    "Preparer",
    "Approver",
    "Tags",
    "Due Days",
    "Account No",
    "Priority",
    "No. of Evidences",
    "Skip Validation",
  ],
      
  ASK_NOA_LABEL: 'Ask Noa',
  BOT_NAME: 'Noa Agent',
  CUSTOM:"custom_",
  MATERIALITYTYPES:['materialityrulevel','materialitygllevel','bulkmaterialityrulevel','bulkmaterialitygllevel','filematerialityrulevel','filematerialitygllevel','materialitysllevel','bulkmaterialitysllevel','filematerialitysllevel'],
  
  // Reconciliation Table Configuration
  RECONCILIATION_TABLE: {
    COLUMN_WIDTHS: {
      PARTICULARS: '45%',
      FILE_REFERENCE: '25%',
      SUB_AMOUNT: '15%',
      FINAL_AMOUNT: '15%'
    },
    COLUMN_WIDTHS_SUMMARY: {
      DESCRIPTION: '50%',
      SUB_AMOUNT: '25%',
      FINAL_AMOUNT: '25%'
    },
    ANIMATION_DURATION: 200,
    TABLE_TYPES: [
      { text: 'Entity View', value: 'entity' },
      { text: 'GL View', value: 'gl' }
    ],
    CLASSES: {
      TABLE_BASE: 'reconciliation-table',
      HEADER_ROW: 'table-header-row',
      GROUP_HEADER: 'group-header',
      GROUP_ITEM: 'group-item',
      COLLAPSIBLE: 'collapsible-header'
    },
    COLORS: {
      HEADER_BG: '#f5f5f5',
      HEADER_BORDER: '#e0e0e0',
      GROUP_HEADER_BG: '#f0f0f0',
      GROUP_HEADER_HOVER: '#e8e8e8',
      GROUP_ITEM_BG: '#fafafa',
      BORDER: '#e0e0e0'
    },
    SPACING: {
      CELL_PADDING: '8px 12px',
      HEADER_PADDING: '12px 16px'
    },
    // Static text constants
    TEXT: {
      RECONCILIATION_SUMMARY: 'Reconciliation Summary',
      RECONCILIATION_DETAILS: 'Reconciliation Details',
      RECON_AMOUNT: 'Recon Amount',
      RECONCILLATION_SUMMARY_API: 'Reconcillation Summary', // Note: API returns with typo
      RECONCILIATION_SUMMARY_API: 'Reconciliation Summary', // Note: API returns with typo
      UNEXPLAINED_DIFFERENCE: 'Unexplained difference',
      TRAIL_BALANCE_TOTAL: 'Trail Balance',
      TOTAL_EXCLUDED: 'Total Excluded',
      TOTAL_AMOUNT_AS_PER: 'total amount as per',
      TOTAL_AMOUNT_AS_PER_TABLE2: 'total amount as per table 2',
      UNMATCHED_TOTAL_IN: 'unmatched total in',
      UNMATCHED_TOTAL_IN_TABLE1: 'unmatched total in table 1',
      GROUP_TABLE_1_TOTAL: 'total in table 1',
      GROUP_TABLE_2_TOTAL: 'total in table 2',
      ADD_PREFIX: 'Add : ',
      LESS_PREFIX: 'Less : ',
      LOADING_TEXT: 'Loading reconciliation data...',
      NO_DATA_AVAILABLE: 'No data available',
      ANALYSIS_NOT_RUN: 'Analysis has not yet been run',
      NO_RECONCILIATION_DETAILS: 'No Reconciliation Details Available',
      // Table headers
      DESCRIPTION: 'Description',
      SUB_AMOUNT: 'Sub Amount',
      FINAL_AMOUNT: 'Final Amount',
      PARTICULARS: 'Particulars',
      FILE_REFERENCE: 'File Reference'
    },
  },
  STYLES: {
      SIZE: {
        MINI_NAV: 64,
        EXPAND_NAV: 250
      },
      SIDE_NAV: {
        COLLAPSED: {
          OPEN_DELAY: 200,
          ANIMATION_DURATION: 160,
          CLOSE_DELAY: 350,
          FORGIVENESS_ZONE: 16
        },
        EXPANDED: {
          OPEN_DELAY: 300,
          ANIMATION_DURATION: 200,
          CLOSE_DELAY: 500,
          FORGIVENESS_ZONE: 16
        }
      }
  },

  /**
   * Product/subscription key identifiers used across the app.
   */
  PRODUCT_KEYS: {
    FINANCIAL_CLOSE: 'financialclose',
    VARIANCE_ANALYSIS: 'varianceanalysis',
    ADMIN: 'admin',
    PBC: 'pbc',
    TDS_AR: 'tds_ar',
    TDS_AP: 'tds_ap',
    TDS_MONTHLY: 'tds_monthly',
    EARNOUT: 'earnout',
    IA: 'ia',
    BOT: 'bot',
    FLUX: 'flux',
    HELPDESK: 'helpdesk',
  },

  /**
   * Free plan name used for expiry checks.
   */
  PLAN_FREE: 'Free',

  /**
   * Global/shared route paths for non-FC modules.
   */
  ROUTE_PATHS: {
    ROOT: '/',
    VA_ACTUAL_ANALYSIS: '/varianceanalysis/actualanalysis',
    VA_QUEUE: '/varianceanalysis/queue',
    ADMIN_DASHBOARD: '/admin/dashboard',
    PBC_PROJECT: '/pbc/project',
    TDS_HOME: '/tds',
    EARNOUT_PROJECT: '/earnout/project',
    IA_PROJECT: '/ia/project',
    BOT_PROJECT: '/bot/project',
    FLUX_PROJECT: '/flux/project',
    HELPDESK_QUERIES: '/helpdesk/queries',
    MANUALS: '/manuals/index',
    MANUALS_ROOT: '/manuals',
  },

  /**
   * Global API endpoints used outside module stores (e.g., base.vue).
   */
  API_URLS: {
    PROFILE_GET_DETAILS: '/v2/profile/getdetails',
    AUTH_GET_PERMISSION: '/v2/auth/getpermission',
    AUTH_LOGOUT: '/v2/auth/logout',
    COMMENTARY_GET_PAGES: '/v2/commentarybundling/getpages',
    PROFILE_UPDATE: '/v2/userprofile/add',
    ERP_SYNC_TRIAL_BALANCE: 'v2/erp/sync-trialbalance',
  },

  /**
   * localStorage key names.
   */
  STORAGE_KEYS: {
    ENTITY: 'Entity',
    LABELS_LIST: 'labelsList',
    LAST_LOGIN_TIME: 'lastLoginTime',
    USER_OBJ: 'userObj',
  },

  /** Query key for the product pack opened on the manuals page. */
  MANUALS_PRODUCT_QUERY: 'product',

  /**
   * True when the route is the manuals module (`/manuals` or `/manuals/...`).
   */
  isManualsPath(path = '') {
    const root = this.ROUTE_PATHS.MANUALS_ROOT;
    return path === root || String(path).startsWith(`${root}/`);
  },

  /**
   * Product key for manuals availability (`financialclose`, `varianceanalysis`, …).
   * Taken from the first path segment when it is a known PRODUCT_KEYS value.
   */
  resolveManualsProduct(path = '') {
    const first = String(path || '').split('/').filter(Boolean)[0] || '';
    return Object.values(this.PRODUCT_KEYS).includes(first) ? first : '';
  },

  /**
   * Whether the manuals nav item should show for this product and client.
   */
  manualsAreAvailable(manualsState = {}, product = '', clientId = '') {
    return Boolean(manualsState.available)
      && manualsState.availableProduct === product
      && String(manualsState.availableClientId || '') === String(clientId || '');
  },

  /**
   * Vuex module store prefix.
   */
  STORE_MODULE_PREFIX: 'm_',

  /**
   * App registry — declarative list of all products for building the applist.
   * Each entry maps a product code to its display configuration.
   * `permissionKey`: property name on the permission object that must be truthy (if any).
   * `codes`: array of product codes that satisfy this app entry.
   */
  APP_REGISTRY: [
    { codes: ['pbc'], name: 'pbc', displayname: 'Information Workflow', color: 'crisk', avatartext: 'I', link: '/pbc/project', permissionKey: 'pbc_project' },
    { codes: ['tds_ar', 'tds_ap', 'tds_monthly'], name: 'tds', displayname: 'Witholding Tax', color: 'ccompliance', avatartext: 'T', link: '/tds', permissionKey: 'tds_monthly', permissionOnlyCodes: ['tds_monthly'] },
    { codes: ['earnout'], name: 'earnout', displayname: 'Earnouts', color: 'ctransaction', avatartext: 'E', link: '/earnout/project' },
    { codes: ['financialclose'], name: 'financialclose', displayname: 'Financial Close', color: 'caccounting', avatartext: 'F', link: '/financialclose/home' },
    { codes: ['ia'], name: 'ia', displayname: 'Internal Audit', color: 'crisk', avatartext: 'IA', link: '/ia/project' },
    { codes: ['bot'], name: 'bot', displayname: null, color: 'crisk', avatartext: 'A', link: '/bot/project', permissionKey: 'bot_project', useBotName: true },
    { codes: ['flux'], name: 'flux', displayname: 'Flux Management', color: 'caccounting', avatartext: 'F', link: '/flux/project' },
    { codes: ['helpdesk'], name: 'helpdesk', displayname: 'Help Desk', color: 'primary', avatartext: 'H', link: '/helpdesk/queries' },
    { codes: ['varianceanalysis'], name: 'varianceanalysis', displayname: 'Commentary', color: 'caccounting', avatartext: 'C', link: '/varianceanalysis/actualanalysis' },
    { codes: ['admin'], name: 'admin', displayname: 'Admin', color: 'primary', avatartext: 'A', link: '/admin/client' },
  ],

};
